.container {
  order: 0;
  margin: 0 1.6rem 1.6rem;

  @media (min-width: $bp-medium) {
    order: 3;
  }
}

.trigger {
  cursor: pointer;
}

.menu-dialog {
  background-color: #181a1e;
  z-index: 9999;
  width: 23.2rem;
  border-radius: var(--border-radius-medium);
  padding: 0.8rem 0;
  max-height: 56rem;
  overflow: auto;
}

.separator {
  background-color: #494e5a;
  height: 1px;
  width: 100%;
  margin-bottom: 0.8rem;
}

.icon-container {
  color: var(--text-color-white);
  font-weight: 500;
  padding: 0.2rem;
  display: flex;
  align-items: center;
  border-radius: 0.8rem;
  height: 3.2rem;
  width: 3.2rem;
  transition: all 150ms linear;
  border: 0.2rem transparent solid;

  &[data-active='true'] {
    border: 0.2rem #494e5a solid;
  }

  svg {
    width: 1.8rem;
    height: 1.8rem;
    fill: var(--text-color-white);
  }

  &:hover {
    cursor: pointer;
    border: 0.2rem #929292 solid;

    &[data-active='true'] {
      border: 0.2rem white solid;
    }
  }
}

.name {
  font-size: 1.4rem;
  font-weight: 400;
  margin-left: 1.2rem;
  color: #7a8296;
  word-break: break-all;

  &[data-active='true'] {
    color: white;
  }
}

.menu-item {
  width: 100%;
  padding: 0.6rem 0.8rem;
  display: flex;
  align-items: center;
  transition: all 100ms ease-in;
  overflow: hidden;
  cursor: pointer;

  &[data-active='true'] {
    background-color: #25272d;
  }

  &:not(:last-child) {
    margin-bottom: 0.4rem;
  }

  &[data-highlighted] {
    background-color: #25272d;

    & > .icon-container {
      cursor: pointer;
      border: 0.2rem #494e5a solid;

      &[data-active='true'] {
        border: 0.2rem #494e5a solid;
      }
    }

    & > .name {
      color: white;
    }
  }
}

.icon {
  font-size: 1.6rem;
  color: #7a8296;
  cursor: pointer;
  display: flex;
  padding: 0.8rem;
  height: 2.4rem;
  width: 2.4rem;
  align-items: center;
  justify-content: center;

  svg {
    fill: #7a8296;
  }
}

.selected-space-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;

  & > svg {
    min-width: 1.6rem;
  }
}

.selected-space {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.space-name {
  font-size: 1.4rem;
  font-weight: 500;
  color: var(--color-grayscale-white, #fafafa);
  text-transform: capitalize;
  word-break: break-all;
}
